import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { BffAdminApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BffAdminApiModule {
    public static forRoot(configurationFactory: () => BffAdminApiConfiguration): ModuleWithProviders<BffAdminApiModule> {
        return {
            ngModule: BffAdminApiModule,
            providers: [ { provide: BffAdminApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BffAdminApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BffAdminApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
